import { isExistingSiteEntryMode } from 'config/entry-mode';
import { useEffect, useRef } from 'react';
import { useAppStore } from 'stores/appStore';
import { SelectableProduct } from 'types/selectable-product';
import { resolveInitialSelectedProducts } from 'utils/product-selection';

export function useSyncProductSelection(products: SelectableProduct[], isReady: boolean) {
  const entryMode = useAppStore((state) => state.entryMode);
  const setSelectedProducts = useAppStore((state) => state.setSelectedProducts);
  const isExistingSiteMode = isExistingSiteEntryMode(entryMode);
  const hasInitializedSelection = useRef(false);

  useEffect(() => {
    if (!isReady || products.length === 0) {
      return;
    }

    const selectedProducts = useAppStore.getState().selectedProducts;
    const shouldPreselectWhenEmpty = isExistingSiteMode && !hasInitializedSelection.current;
    const nextSelectedProducts = resolveInitialSelectedProducts(selectedProducts, products, shouldPreselectWhenEmpty);

    if (shouldPreselectWhenEmpty && selectedProducts.length === 0) {
      hasInitializedSelection.current = true;
    }

    if (nextSelectedProducts) {
      setSelectedProducts(nextSelectedProducts);
    }
  }, [isExistingSiteMode, isReady, products, setSelectedProducts]);
}
